import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import firebase from 'firebase';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
var production = false;
// development credentials
var config = {
  apiKey: "AIzaSyDu-6I0JQH-kpRHGJHSgape7uxJDW8qucE",
  authDomain: "scholarlib-dev.firebaseapp.com",
  databaseURL: "https://scholarlib-dev.firebaseio.com",
  projectId: "scholarlib-dev",
  storageBucket: "scholarlib-dev.appspot.com",
  messagingSenderId: "860218948753"
}

if (process.env.NODE_ENV === 'production') {
  // production credentials
  config = {
    apiKey: 'AIzaSyCxzwjAwrTzSlbJ0rmbNrxr2zGl7pLzyXY',
    authDomain: 'scholarlib-ea55a.firebaseapp.com',
    databaseURL: 'https://scholarlib-ea55a.firebaseio.com',
    projectId: 'scholarlib-ea55a',
    storageBucket: 'scholarlib-ea55a.appspot.com',
    messagingSenderId: '847501825791',
  };
}

firebase.initializeApp(config);
Vue.use(BootstrapVue);

export const db = firebase.firestore();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
